// extracted by mini-css-extract-plugin
module.exports = {"date-cell":"DateCell_date-cell__2R8N_"};